import React, { useEffect, useRef, useState } from "react";
import { Button, Label, Icon, Input, Container, Segment, Grid, Message, Dropdown, Form } from "semantic-ui-react";
import "./MobileViewLive.css";
import { changeFormatLongDateWithOptionalTime, changeInitialScale, loadingShowLogo, numberToCharTG } from "../myfunctions";
import noimage from '../assets/noimage.png';
import tgsmallv1 from '../assets/tgsmallv1.png';
import tgsmallv2 from '../assets/tgsmallv2.png';
import { ConnectWS } from "../ConnectWS";
import { Toaster, toast } from "react-hot-toast";
import { LazyLoadImage } from "react-lazy-load-image-component";
import useWindowDimensions from "../hooks/useWindowDimensions";
import MapaApp from "./MapaApp";
import 'react-image-lightbox/style.css'; // bardzo ważne – import stylów!
import Lightbox from 'react-image-lightbox';

export function getColorEvent(statusLive) {
  if (statusLive === 3) {
    return "blue"
  } else if (statusLive === 2) {
    return "red"
  } else {
    return "grey"
  }
}


const MobileViewLive = () => {
  const [tournaments, setTournaments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const now = new Date();
  const { width, height } = useWindowDimensions();// eslint-disable-line no-unused-vars
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [selectedTournamentId, setSelectedTournamentId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(() => setDeferredPrompt(null));
    }
  };

  useEffect(() => {
    changeInitialScale(0.7)
    generateHotPayDataSubscription();
    return () => { changeInitialScale(1) };
  }, []);// eslint-disable-line react-hooks/exhaustive-deps



  const [selectedSport, setSelectedSport] = useState(null);

  const sportOptions = [...new Set(tournaments.map(t => t.points_calc_system_name))].map(sport => ({
    key: sport,
    text: sport,
    value: sport
  }));

  const filterBySearchAndSport = (list) => {
    return list.filter((t) => {
      const matchesSearch = t.tournament_name.toLowerCase().includes(search.toLowerCase());
      const matchesSport = selectedSport ? t.points_calc_system_name === selectedSport : true;
      return matchesSearch && matchesSport;
    });
  };



  function statusLive(t) {
    try {
      if (new Date(t?.start_date) > now) {
        return 3
      } else if (new Date(t?.start_date) < now && new Date(t?.stop_date) > now) {
        return 2
      } else {
        return 1
      }
    } catch (e) {
      console.log(e)
      return 1
    }

    // 1 - rozegrany
    // 2 - live
    // 3 - nowy 
  }

  function generateHotPayDataSubscription() {
    setLoading(true);
    ConnectWS("/mobile/getCurrentTournaments", null, {}, function (response, logout) {
      if (logout === 1) {
      } else if (response && response.status && Number(response.status) === 200) {
        if (response.data) {
          setTournaments(response.data.map((row) => ({ ...row, statusLive: statusLive(row) })).sort((a, b) => b.statusLive - a.statusLive || new Date(b.start_date) - new Date(a.start_date)))

        }
      } else {
        if (logout === 101) {
          toast(response)

        } else if (logout === 102) {
          toast(response)
        } else {
          toast(response)
        }
      }
      setLoading(false);
    });
  }





  function getEventDaysPassed(start, stop) {
    const startDate = new Date(start);
    const stopDate = new Date(stop);
    const today = new Date();

    // Jeśli dzisiaj jest przed startem → 0 dni
    if (today < startDate) return 0;

    // Jeśli dzisiaj po zakończeniu wydarzenia → liczba dni = pełne wydarzenie
    if (today > stopDate) return Math.ceil((stopDate - startDate) / (1000 * 60 * 60 * 24));

    // W przeciwnym wypadku liczba dni od startu do dzisiaj
    return Math.ceil((today - startDate) / (1000 * 60 * 60 * 24));
  }






  const renderTournament = (t) => {
    const isSelected = t.tournament_id === selectedTournamentId;
    const hasImage = !!t.img_file; // Sprawdzenie, czy turniej ma grafikę

    return (
      <Segment key={t.tournament_id} className={`news-card ${isSelected ? 'selected-mobile' : ''}`} onClick={() => setSelectedTournamentId(t.tournament_id)}>
        <div className={`news-image-container-mobile ${!hasImage ? 'no-photo' : ''}`}>
          <LazyLoadImage
            alt={t.tournament_name}
            onClick={(e) => { e.stopPropagation(); t.img_file && setIsOpen(t.img_file); }}
            // Jeśli nie ma obrazka, używamy logotypu jako znaku wodnego
            src={t.img_file || tgsmallv2}
            className={hasImage ? "news-img" : "mobile-placeholder-logo"}
            onError={e => { if (e.target.src !== tgsmallv2) e.target.src = tgsmallv2; }}
          />
          <div className={`news-badge ${getColorEvent(t.statusLive)}`}>
            {t?.statusLive === 3 ? "Zaplanowane do 7 dni" : t?.statusLive === 2 ? <>Na żywo od {getEventDaysPassed(t.start_date, t.stop_date)} dni</> : "Rozegrane do 7 dni "}
          </div>
        </div>
        <div className="news-content-mobile">
          <h4 className="news-title">{t.tournament_name}</h4>
          <div className="news-description">
            <p><Icon name="calendar alternate" />Rozpoczęcie: {changeFormatLongDateWithOptionalTime(t.start_date, true)} <br />
              <Icon name="calendar alternate" />Zakończenie: {changeFormatLongDateWithOptionalTime(t.stop_date, true)} <br />
              <Icon name="user" /> Organizator: {t.organizer_name}
              {t.register_online === 1 ? (
                <p><Icon name="user" /> Rejestracja online</p>
              ) : (
                ""
              )}</p>
            <p><Icon name="marker" /> {t.place ? <>{JSON.parse(t.place).address} ({JSON.parse(t.place).description})</> : "Brak lokalizacji"}</p>
          </div>
          <div className="news-footer-mobile">

            <Label >{t.points_calc_system_name}</Label>
            <Button color={getColorEvent(t.statusLive)} size="small" onClick={() => window.location.href = ("https://tg-app.pl/tg/" + numberToCharTG(t.tournament_id))}>Szczegóły</Button>


          </div>
        </div>
      </Segment>
    );
  };

  const renderTournamentDesktop = (t) => {
    const isSelected = t.tournament_id === selectedTournamentId;
    const hasImage = !!t.img_file; // Sprawdzenie czy jest obrazek
    return (
      <div key={t.tournament_id} ref={(el) => { refs.current[t.tournament_id] = el; }}
        className={`news-card-desktop-horizontal ${isSelected ? 'selected' : ''}`}
        onClick={() => setSelectedTournamentId(t.tournament_id)}>
        <Grid columns={16} style={{ margin: 0 }}>
          <Grid.Row style={{ display: 'flex', alignItems: 'stretch', padding: 0 }}>
            <Grid.Column width={6} className="no-padding">
              {/* DODANO: dynamiczna klasa no-photo */}
              <div className={`news-image-wrapper-horizontal ${!hasImage ? 'no-photo' : ''}`}>
                <LazyLoadImage
                  alt={t.tournament_name}

                  // Jeśli nie ma obrazka, używamy logotypu jako znaku wodnego
                  src={t.img_file || tgsmallv2}
                  className={hasImage ? "news-img-horizontal" : "news-img-horizontal placeholder-logo"}
                  onError={e => { if (e.target.src !== tgsmallv2) e.target.src = tgsmallv2; }}
                />
                <div className={`news-badge-mini ${getColorEvent(t.statusLive)}`}>
                  {t?.statusLive === 3 ? "Zaplanowane do 7 dni" : t?.statusLive === 2 ? <>Na żywo od {getEventDaysPassed(t.start_date, t.stop_date)} dni</> : "Rozegrane do 7 dni "}
                </div>
              </div>
            </Grid.Column>
            <Grid.Column width={10} className="no-padding">
              <div className="news-content-horizontal">
                <div className="news-text-block">
                  <h4 className="news-title-desktop">{t.tournament_name}</h4>
                  <div className="news-meta-horizontal">
                    <p><Icon name="calendar alternate" />Rozpoczęcie: {changeFormatLongDateWithOptionalTime(t.start_date, true)} <br />
                      <Icon name="calendar alternate" />Zakończenie: {changeFormatLongDateWithOptionalTime(t.stop_date, true)} <br />
                      <Icon name="user" /> Organizator: {t.organizer_name}
                      {t.register_online === 1 ? (
                        <p><Icon name="user" /> Rejestracja online</p>
                      ) : (
                        ""
                      )}
                    </p>
                    <p className="place-text"><Icon name="marker" /> {t.place ? <>{JSON.parse(t.place).address} ({JSON.parse(t.place).description})</> : "Brak lokalizacji"}</p>
                  </div>
                </div>
                <div className="news-footer-horizontal">

                  <Label >{t.points_calc_system_name}</Label>
                  <Button basic color={getColorEvent(t.statusLive)} size="small" onClick={() => window.location.href = ("https://tg-app.pl/tg/" + numberToCharTG(t.tournament_id))}>Szczegóły</Button>


                </div>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  };




  const refs = useRef({});
  // 💡 FUNKCJA PRZEWIJANIA
  const handleSelectAndScroll = (tournamentId) => {
    setSelectedTournamentId(tournamentId);

    // Znajdź referencję do wybranego elementu na liście
    const element = refs.current[tournamentId];
    if (element) {
      // Logowanie do weryfikacji, czy element został znaleziony
      // console.log("Przewijanie do elementu:", element); 
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest' // Powinno działać dobrze w większości przypadków
      });
    } else {
      // console.log("Nie znaleziono elementu o ID:", tournamentId);
    }
  };






  function getViewData(renderTournamentView) {
    return <>
      {filterBySearchAndSport(tournaments).length > 0 ? (
        filterBySearchAndSport(tournaments).map((t) => renderTournamentView(t, true))
      ) : (
        <Message>Brak  turniejów</Message>
      )}
    </>
  }

  return <div className="tg-body">{loading ? (
    <div style={{ marginTop: 40 }}>{loadingShowLogo(false)}</div>
  ) : (
    width < 900 ? <> <div className="mv-search-box">
      {deferredPrompt && (
        <Button
          onClick={handleInstall}
          color="blue" fluid
        >
          Zainstaluj aplikację
        </Button>
      )}
      <Grid style={{ margin: 0, padding: 0 }}>
        <Grid.Row verticalAlign="middle">
          <Grid.Column style={{ margin: 0, padding: 5, paddingTop: 6 }} mobile={1} tablet={1} computer={1}>

            <img src={tgsmallv1} alt="Logo" style={{ width: 40 }} />
          </Grid.Column>
          <Grid.Column style={{ margin: 0, padding: 5, paddingTop: 6 }} mobile={9} tablet={9} computer={9}>

            <Input
              icon="search"
              placeholder="Szukaj turnieju..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              fluid
            />
          </Grid.Column>
          <Grid.Column style={{ margin: 0, padding: 5 }} mobile={6} tablet={6} computer={6}>
            <Dropdown
              placeholder='Wybierz sport'
              fluid
              selection
              clearable
              options={sportOptions}
              onChange={(e, { value }) => setSelectedSport(value)}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

    </div>

      <Container style={{ marginTop: 7, paddingBottom: 20 }}>


        <div className="mv-container">
          {getViewData(renderTournament)}

        </div>
      </Container>


      <Toaster position="top-right" />
    </>
      : <>
        <Grid stackable style={{ margin: 0, padding: 1, height: "100vh", overflow: "hidden" }}>

          <Grid.Row style={{ margin: 0, padding: 0, }}>

            <Grid.Column style={{ margin: 0, padding: 0, height: "100vh", overflow: "auto" }} width={8}>
              <div style={{width: "98%",margin:"0 auto"}} >
                <Form>
                  <Form.Group widths='equal'>
                    <Input
                      style={{ width: 440 }}
                      icon="search"
                      placeholder="Szukaj turnieju..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}

                    />
                    <Dropdown
                      placeholder='Wybierz sport'
                      fluid
                      selection
                      clearable
                      options={sportOptions}
                      onChange={(e, { value }) => setSelectedSport(value)}
                    />
                  </Form.Group>
                </Form>

              </div>
              <div style={{ padding: 15 }}>
                {getViewData(renderTournamentDesktop)}
              </div>

            </Grid.Column>
            <Grid.Column style={{ margin: 0, padding: 5 }} width={8}>
              <MapaApp selectedTournamentId={selectedTournamentId} dataInMap={filterBySearchAndSport(tournaments) || []} onMarkerClick={handleSelectAndScroll} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>)}
    {isOpen && (
      <Lightbox
        mainSrc={isOpen || noimage} // główny obrazek
        onCloseRequest={() => setIsOpen(null)} // zamykanie lightboxa
      />
    )}
  </div>;
};

export default MobileViewLive;
